import MRSSFeedsSelect from './MRSSFeedsSelect';

export default MRSSFeedsSelect;
